<template>
    <div class='accordion-container'>
        <div class="accordion-collapse-container col-12">
            <a href="javascript:void(0)" @click="uncollapseAll()" v-if="showCollapseAll === false" class="collapseLink">Uncollapse All</a>
            <a href="javascript:void(0)" @click="collapseAll()" v-if="showCollapseAll === true"  class="collapseLink">Collapse All</a>
        </div>
        <div class="accordion-items col-12">
            <slot></slot>
        </div>
    </div>
</template>
<script>
export default {
    name:"AccordionList",
    data() {
        return {
            items: [],
            showCollapseAll: false
        };
    },
    created() {
        this.items = this.$children;
    },
    methods: {
        uncollapseAll() {
            this.items.forEach(item => {
                item.isActive = true;
            });
            this.showCollapseAll = true;
            this.$emit('resize');
        },
        collapseAll() {
            this.items.forEach(item => {
                item.isActive = false;
            });
            this.showCollapseAll = false;
            this.$emit('resize');
        }
    }
}
</script>
